module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ペリスコピック望遠カメラ.766a73fd.png";